import {
  ErrorsPayload,
  ErrorsResponse,
  ErrorStatus,
  UpdateErrorStatusPayload,
  GetErrorsPayload,
} from '@oare/types';
import axios from '../axiosInstance';

async function logError(payload: ErrorsPayload): Promise<void> {
  await axios.post('/errors', payload);
}

async function getErrorLog(payload: GetErrorsPayload): Promise<ErrorsResponse> {
  const { data } = await axios.get('/errors', {
    // The route parses this back out with JSON.parse, so serialize it here
    // rather than relying on how axios flattens a nested object.
    params: {
      payload: JSON.stringify(payload),
    },
  });
  return data;
}

async function updateErrorStatus(
  uuids: string[],
  status: ErrorStatus
): Promise<void> {
  const payload: UpdateErrorStatusPayload = {
    uuids,
    status,
  };
  await axios.patch('/errors', payload);
}

async function newErrorsExist(): Promise<boolean> {
  // Badge check, often from the background poll: never redirect to an error page.
  const { data } = await axios.get('/newerrors', { skipErrorPage: true });
  return data;
}

export default {
  logError,
  getErrorLog,
  updateErrorStatus,
  newErrorsExist,
};
